const totals = {
  'totals.credits': 'Credits',
  'totals.current_balance': 'Current balance',
  'totals.previous_balance': 'Previous balance',
  'totals.exchange_rate': 'Exchange rate',
  'totals.debits': 'Transactions',
  'totals.international_debits': 'International Debits',
  'totals.partial.invoice': 'Transactions',
  'totals.amountPaid': 'Amount Paid: {value}',
};

export default totals;
